
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.03 5.22a.755.755 0 010 1.064L8.56 8.752h6.88l-2.47-2.468a.75.75 0 111.06-1.065l3.53 3.533h2.69a.751.751 0 010 1.5h-.125l-1.163 6.405a2.252 2.252 0 01-2.214 1.845H7.252a2.252 2.252 0 01-2.213-1.845l-1.164-6.405H3.75a.751.751 0 010-1.5h2.69l3.53-3.533a.75.75 0 011.06 0zM5.4 10.251l1.115 6.135a.753.753 0 00.738.615h9.496a.752.752 0 00.737-.615l1.117-6.135H5.398zM8.5 11.759a.752.752 0 01.864.623l.374 2.25a.75.75 0 01-.615.862.752.752 0 01-.864-.622l-.374-2.25a.75.75 0 01.615-.863zm6.998 0a.75.75 0 01.615.863l-.375 2.25a.752.752 0 01-.863.622.75.75 0 01-.615-.862l.375-2.25a.752.752 0 01.863-.623zM12 11.752c.414 0 .75.337.75.75v2.25a.751.751 0 01-1.5 0v-2.25c0-.413.336-.75.75-.75z"}})])
          )
        }
      }
    